import {
  BlockWrapper,
  useInspectorControl,
  defineBlock,
  useEditor,
  smartProps,
  ChildrenBlock,
} from "@smartfire/js-block-engine";
import { lazy } from "react";
import { EditableText } from "@smartfire/components";
import background from "./assets/bg.webp";
import style from "./block.module.scss";

const Inspector = lazy(() => import("./inspector.js"));

const ValueProposition = ({ buttonUrl, mainImage }) => {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();

  const TagName = isEditing ? "p" : "a";

  const allowedBlocks = ["core/heading"];

  const template = [
    [
      "core/heading",
      {
        placeholder:
          "For thriving gardens and pest-free homes, just ask Seezon.",
        level: 3,
      },
    ],
  ];

  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.leafsContainer}>
        <div className={style.leafs} />
      </div>
      <div className={style.imageContainer}>
        <img
          src={mainImage ? mainImage.url : background}
          alt="Background"
          loading="lazy"
        />
      </div>
      <div className={style.contentContainer}>
        <ChildrenBlock
          key="children"
          gutenbergEditorConfig={{
            orientation: "vertical",
            allowedBlocks: allowedBlocks,
            template: template,
          }}
          className={style.content}
        />

        {(isEditing || buttonUrl !== "") && (
          <TagName
            href={!isEditing && buttonUrl !== "" && buttonUrl}
            className={style.discoverButton}
          >
            <EditableText smartProp="buttonText" placeholder="Discover" />
          </TagName>
        )}
      </div>
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: ValueProposition,
  smartProps: {
    mainImage: smartProps.image,
    buttonText: smartProps.string.withDefault("Discover"),
    buttonUrl: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Value Proposition",
  },
});
